import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import CreateDeploymentDialog from "../../components/CreateDeploymentDialog";
import { useSelector } from "react-redux";

export interface DeploymentCreatorProps {
  resourceAppName: string;
  resourceAppId: string;
  version: string;
  refreshDeploymentList: () => void;
  deployedRegions: string[] | undefined;
  basePath: string;
}
export const DeploymentCreator: React.FC<DeploymentCreatorProps> = ({
  resourceAppName,
  resourceAppId,
  version,
  refreshDeploymentList,
  deployedRegions,
  basePath
}) => {
  const { open, toggle } = useDialogProps();
  const onSuccess = () => {
    refreshDeploymentList();
  };

  const identityEnvironment = useSelector((state: any) => state?.common?.identityEnvironment ?? "trimble-pre-prod");
  
  
  const [availableRegions, setAvailableRegions] = useState(
    identityEnvironment === "trimble-prod" ?
    [
    { key: "Global", value: "global" },
      { key: "EU-West", value: "eu-west" },
  ] : [{ key: "Global", value: "global" }]);

  useEffect(() => {
    const baseRegions =  identityEnvironment === "trimble-prod" ?
    [
    { key: "Global", value: "global" },
    { key: "EU-West", value: "eu-west" },

  ] : [{ key: "Global", value: "global" }]

    const updatedRegions = baseRegions.filter((region) => {

      if (deployedRegions?.includes("global")) {
        return region.value !== "global" && !deployedRegions?.includes(region.value);
      }

      return !deployedRegions?.includes(region.value);
    });

    setAvailableRegions(updatedRegions);
  }, [deployedRegions]);


  return (
    <>
        <>
          <Button
            disabled={availableRegions?.length === 0}
            size="large"
            variant="contained"
            color="primary"
            style={{ padding: "30px 21px" }}
            startIcon={<AddIcon />}
            onClick={() => toggle()}
          >
            Add New Deployment
          </Button>
          <CreateDeploymentDialog
            open={open}
            onClose={toggle}
            onSuccess={onSuccess}
            basePath={basePath}
            resourceAppId={resourceAppId}
            version={version}
            availableRegions={availableRegions}

          />
        </>
    </>
  );
};